import { Button } from "@devhop/ui";
import { useNavigate, useParams } from "@tanstack/react-router";
import { ArrowLeftIcon, PrinterIcon } from "lucide-react";
import { Header } from "@/app/layout/Header";
import { Main } from "@/app/layout/Main";
import { useSOPDetailQuery } from "../api/queries";
import { SOPPdfPreviewContent } from "../ui/SOPPdfPreviewContent";

export function SOPPdfPreviewPage() {
  const { id } = useParams({ from: "/app/sop/$id/pdf-preview" });
  const nav = useNavigate({ from: "/app/sop/$id/pdf-preview" });

  const { data: sop, isLoading, error } = useSOPDetailQuery(id);

  const handleBack = () => {
    nav({ to: "/app/sop/$id", params: { id } });
  };

  const handlePrint = () => {
    window.print();
  };

  const handleDownloadPDF = () => {
    // Show instructions to user
    const confirmed = confirm(
      "ต้องการสร้าง PDF?\n\n" +
        "1. คลิก 'OK' เพื่อเปิดหน้าต่างพิมพ์\n" +
        "2. ในหน้าต่างพิมพ์ เลือก 'Save as PDF' หรือ 'Print to PDF'\n" +
        "3. เลือกขนาดกระดาษ A4 และ Orientation Portrait\n" +
        "4. คลิก 'Save' หรือ 'Print' เพื่อสร้างไฟล์ PDF",
    );

    if (confirmed) {
      window.print();
    }
  };

  if (isLoading) {
    return (
      <>
        <Header />
        <Main>
          <div className="flex min-h-[400px] items-center justify-center">
            <div className="text-center">
              <div className="mx-auto h-8 w-8 animate-spin rounded-full border-primary border-b-2" />
              <p className="mt-2 text-muted-foreground">ກໍາລັງໂຫຼດ...</p>
            </div>
          </div>
        </Main>
      </>
    );
  }

  if (error || !sop) {
    return (
      <>
        <Header />
        <Main>
          <div className="flex min-h-[400px] items-center justify-center">
            <div className="text-center">
              <h2 className="mb-2 font-bold text-2xl text-destructive">
                ບໍ່ພົບ SOP
              </h2>
              <p className="mb-4 text-muted-foreground">
                SOP ທີ່ທ່ານຊອກຫາບໍ່ມີຢູ່ ຫຼື ຖືກລຶບໄປແລ້ວ
              </p>
              <Button onClick={handleBack}>
                <ArrowLeftIcon className="mr-2 h-4 w-4" />
                ກັບໄປທີ່ SOP
              </Button>
            </div>
          </div>
        </Main>
      </>
    );
  }

  return (
    <>
      <Header />

      <Main>
        {/* Header Actions - Hidden in print */}
        <div className="mb-6 flex items-center justify-between print:hidden">
          <Button variant="ghost" onClick={handleBack} className="gap-2">
            <ArrowLeftIcon className="h-4 w-4" />
            ກັບໄປທີ່ SOP
          </Button>

          <div className="flex items-center gap-2">
            <Button variant="outline" onClick={handlePrint} className="gap-2">
              <PrinterIcon className="h-4 w-4" />
              ພິມ
            </Button>
          </div>
        </div>

        {/* PDF Preview Content */}
        <SOPPdfPreviewContent sop={sop as any} />
      </Main>
    </>
  );
}
